import styled from "styled-components";

export const PostImagesContainer = styled.div`
  display: flex;
  width: 100%;
  height: 136px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;

  & img {
    height: 100%;
    object-fit: cover;
  }

  &.img-1 {
    & img {
      width: 100%;
    }
  }

  &.img-2 {
    position: relative;
    width: 100%;

    & img {
      position: absolute;
      width: 50%;
      top: 0;
      bottom: 0;
      left: 0;
    }

    & :last-child {
      position: absolute;
      width: 50%;
      top: 0;
      bottom: 0;
      left: 50%;
      right: 0;
    }
  }

  &.img-3 {
    position: relative;
    width: 100%;
    background-color: #000;

    & img {
      position: absolute;
      width: 50%;
      top: 0;
      bottom: 0;
      left: 0;
    }

    & .img2 {
      position: absolute;
      width: 50%;
      top: 0;
      bottom: 0;
      left: 50%;
      right: 0;
      opacity: 0.3;
    }

    & div {
      position: absolute;
      top: calc(50% - 16px);
      left: 75%;
      left: calc(75% - 15.5px);
      z-index: 1;
      font-size: 24px;
      line-height: 32px;
      font-weight: 700;
      color: #fff;

      display: flex;

      & span {
      }
    }
  }
`;
